import { useTranslation } from 'react-i18next';
import { Icon } from '@mui/material';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import CommonDropzone from '../../../../../components/common-dropzone/CommonDropzone';
import AttemptsCount from '../AttemptsCount';
import CommonLoader from '../../../../../components/common-loader/CommonLoader';

import scss from './UploadCard.module.scss';

function UploadCard({ onShowUploadModal, isValid, onValidate }) {
  const { t } = useTranslation('id8');

  const isGenerating = useSelector((state) => state.demoRecreate.isGenerating);

  const handleDrop = (files) => {
    onShowUploadModal(files);
  };

  const handleValidate = () => {
    if (!isValid) {
      onValidate();
      return;
    }
  };

  return (
    <div className={scss.wrapper}>
      <CommonDropzone onDrop={handleDrop} disabled={isGenerating || !isValid}>
        {({ isDragAccept }) => (
          <div
            className={scss.uploaderBlock}
            onClick={handleValidate}
            role='button'
            onKeyDown={handleValidate}
            tabIndex={0}>
            <Icon
              component={AddPhotoAlternateOutlinedIcon}
              baseClassName={clsx(scss.uploaderIcon, isDragAccept && scss.uploaderIconFocused)}
            />
            <span>{t('uploadYourAdHere')}</span>
            <AttemptsCount />
          </div>
        )}
      </CommonDropzone>

      <CommonLoader isLoading={isGenerating} />
    </div>
  );
}

export default UploadCard;
